var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_vm._v("\n      "+_vm._s(_vm.$t('maintenanceModeScreen.title'))+"\n    ")]),_c('div',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.$t('maintenanceModeScreen.description'))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }